import styled from "styled-components";
import { Input as AntdInput } from "antd";
import { COLORS } from "../../const";

export const Input = styled(AntdInput)`
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  padding: 6px 12px;
  height: 32px;
  color: ${COLORS["gray-800"]};
`;

export const TextArea = styled(AntdInput.TextArea)`
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  padding: 8px 12px;
  color: ${COLORS["gray-800"]};
  ${(props) => props.minHeight && `min-height: ${props.minHeight} !important;`}
`;
